import {
  Box,
  Container,
  Flex,
  Button,
  Heading,
  Text,
} from '@chakra-ui/react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import React from 'react';
import { Link, graphql, useStaticQuery } from 'gatsby';
import FlareGroup7 from '../../assets/shapes/shape-group-7.svg';
import { HalfByHalfSection } from '../_index';

const wetheBest = {
  header:
    'We are the <span className="highlight">Best</span> Way to Sell Your Home in the Bay Area, CA',
  content:
    'Whether you are trying to avoid an imminent foreclosure, inheriting a property you don’t like/need, dealing with a divorce, or are fed up being a landlord dealing with bad tenants - we can help. If you need to sell your home in the Bay Area fast… we offer CASH for homes in the Bay Area, CA!',
};

const FrictionReducer = () => (
  <Flex flexDir="column">
    <Heading
      as="h3"
      size="xl"
    >
      We Buy Houses in the Bay Area in any condition
      {' '}
      <span className="highlight">
        No realtors, no fees, no commission and best of all, no
        repairs or cleaning necessary.
      </span>
    </Heading>
    {/* <Link to="/get-offer">
      <Button
        mt={10}
        variant="btnCTA"
        size="lg"
        isLoading={false}
        type="submit"
      >
        Get Your Free offer
      </Button>
    </Link> */}
  </Flex>
);

const ContentBlock = ({ location }) => (
  <>
    <Heading
      as="h4"
      size="2xl"
      mb={4}
    >
      We are the
      {' '}
      <span className="highlight">Best</span>
      {' '}
      local home
      buyers in
      {' '}
      {location}
      , CA
    </Heading>
    <Text fontSize="2xl">
      Whether you are trying to avoid an imminent foreclosure,
      inheriting a property you don’t like/need, dealing with a
      divorce, or are fed up being a landlord dealing with bad tenants
      - we can help. If you need to sell your home in the Bay Area
      fast… we offer CASH for homes in the Bay Area, CA!
    </Text>
  </>
);

const FlareBlock = ({ img }) => (
  <Box
    zIndex="0"
    height={{ base: '15rem', md: '25rem' }}
  >
    <Box
      transform={{ base: 'scale(.7)', md: 'scale(1)' }}
      position="relative"
      width="20rem"
      mx="auto"
      height="20rem"
    >
      <Box
        position="absolute"
        top={{ base: '0%', md: '-20%' }}
      >
        <FlareGroup7 className="width-400 height-500 width-md-600 height-md-600" />
      </Box>
      <Box
        position="absolute"
        top={{ base: '0%', md: '20%' }}
      >
        <GatsbyImage
          className="width-300"
          alt="happy home buyers image"
          image={img}
        />
      </Box>
    </Box>
  </Box>
);

const WeTheBestSection = ({ location = 'The Bay Area' }) => {
  const { flareImage } = useStaticQuery(query);
  const image = getImage(flareImage);
  return (
    <Box py={4}>
      <Container maxW="container.xl">
        <HalfByHalfSection
          location={location}
          left={<FrictionReducer />}
          right={<FlareBlock img={image} />}
        />
      </Container>
    </Box>
  );
};

export const query = graphql`
  query {
    flareImage: file(
      relativePath: { eq: "people/women-coffee.png" }
    ) {
      childImageSharp {
        gatsbyImageData(width: 800, placeholder: BLURRED)
      }
    }
  }
`;

export default WeTheBestSection;
